// src/components/common/Header.js
import React, { useState } from 'react';
import { Link, NavLink } from 'react-router-dom';
import { Navbar, Nav, Container } from 'react-bootstrap';

const Header = () => {
    const [expanded, setExpanded] = useState(false);

    return (
        <header className="header-custom shadow-lg" style={{ position: 'sticky', top: 0, zIndex: 1030 }}>
            {/* Top Bar - Logo Centered */}
            <div className="header-top-bar">
                <Container>
                    <div className="header-logo-center">
                        <Link to="/" className="d-inline-block">
                            <img 
                                src="assets/img/logo/media_association_logo.png" 
                                alt="logo" 
                                className="main-logo"
                            />
                        </Link>
                    </div>
                </Container>
            </div>

            {/* Bottom Bar - Navigation Menu */}
            <div className="header-bottom-bar">
                <Container>
                    <div className="header-nav-wrapper">
                        <button
                            className="navbar-toggler-custom d-lg-none"
                            type="button"
                            onClick={() => setExpanded(!expanded)}
                            aria-label="Toggle navigation"
                        >
                            <span className="navbar-toggler-icon"></span>
                        </button>

                        <Navbar 
                            expand="lg" 
                            expanded={expanded}
                            onToggle={() => setExpanded(!expanded)}
                            className="p-0 w-100"
                        >
                            <Navbar.Collapse id="basic-navbar-nav" className="justify-content-center">
                                <Nav className="header-nav mx-auto justify-content-center">
                                    <Nav.Link as={NavLink} to="/" end onClick={() => setExpanded(false)}>
                                        Home
                                    </Nav.Link>
                                    <Nav.Link as={NavLink} to="/about" onClick={() => setExpanded(false)}>
                                        About Us
                                    </Nav.Link>
                                    <Nav.Link as={NavLink} to="/membership" onClick={() => setExpanded(false)}>
                                        Membership
                                    </Nav.Link>
                                    <Nav.Link as={NavLink} to="/members" onClick={() => setExpanded(false)}>
                                        Members
                                    </Nav.Link>
                                    <Nav.Link as={NavLink} to="/committee" onClick={() => setExpanded(false)}>
                                        Committee
                                    </Nav.Link>
                                    <Nav.Link as={NavLink} to="/publications" onClick={() => setExpanded(false)}>
                                        Our Publication
                                    </Nav.Link>
                                    <Nav.Link as={NavLink} to="/contact" onClick={() => setExpanded(false)}>
                                        Contact
                                    </Nav.Link>
                                </Nav>
                            </Navbar.Collapse>
                        </Navbar>
                    </div>
                </Container>
            </div>
        </header>
    );
};

export default Header;